module.exports = __webpack_public_path__ + "img/canbadge_square_44mm_trimmark.5905f202.png";